import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { InsuranceCompany } from '../models/quote.model';

@Injectable({
  providedIn: 'root'
})
export class InsuranceCompanyService {
  private readonly apiUrl = `${environment.apiUrl}/api/v1/insurance-companies`;

  constructor(private http: HttpClient) {}

  getInsuranceCompanies(): Observable<InsuranceCompany[]> {
    return this.http.get<InsuranceCompany[]>(this.apiUrl);
  }

  getInsuranceCompany(id: number): Observable<InsuranceCompany> {
    return this.http.get<InsuranceCompany>(`${this.apiUrl}/${id}`);
  }

  createInsuranceCompany(company: Partial<InsuranceCompany>): Observable<InsuranceCompany> {
    return this.http.post<InsuranceCompany>(this.apiUrl, company);
  }
}
